import {useLocation} from 'react-router-dom';
import productsMessages from './products.en.json';
import servicesMessages from './services.en.json';
import messages from './en.json';
import titles from './siteTitles.en.json';
import newsTitles from './newsTitles.en.json';
import leasingMessages from './leasing.en.json';
import aboutMessages from './about.en.json';
export const normalizeMessage = text => String(text).replace(/\s+/g, ' ').trim();
export const translateText = text => productsMessages[text] || productsMessages[normalizeMessage(text)] || servicesMessages[text] || servicesMessages[normalizeMessage(text)] || leasingMessages[normalizeMessage(text)] || aboutMessages[normalizeMessage(text)] || messages[normalizeMessage(text)] || text;
export function useTranslation() {
    const {pathname} = useLocation();
    const english = /^\/en(?:\/|$)/.test(pathname);
    return {english, t: text => english ? translateText(text) : text};
}
export function localizeStructure(nodes, english, parent = '') {
    if (!english) return nodes;
    return Object.fromEntries(Object.entries(nodes).map(([key, node]) => {
        const path = `${parent}/${key}`;
        return [key, {...node, title: titles[path] || node.title,
            ...(node.links ? {links: localizeStructure(node.links, english, path)} : {})}];
    }));
}
export function localizeNewsTitle(news, english) {
    return english ? newsTitles[news.title] || news.title : news.title;
}
